import {useAppStore} from "../../../StateManager";
import {IconButtonV5} from "../interaction/IconButtonV5";
import BackIcon from "../icons/arrow-narrow-left.svg?react";
import type {AppState} from "../../../data/state/AppState";
import {StringUtils} from "../../../utils/data/string/StringUtils";

export const TopBarBackButtonV5 = () => {
	const appState: AppState = useAppStore((state) => state.appState);
	const navigation = appState.app.navigation;
	const {lastNonSettingsHash} = navigation;

	const onBackClick = () => {
		if (StringUtils.isHashValid(lastNonSettingsHash, appState.currentUIVersion, appState.user)) {
			navigation.go(lastNonSettingsHash);
		} else {
			navigation.goApp({
				organizationId: appState.organizationIdByAuthData,
				mainNav: appState.defaultMenu,
			});
		}
	};

	return (
		<IconButtonV5
			IconComponent={BackIcon}
			onClick={onBackClick}
		/>
	);
};
